// export default async function externalComponent (url: string): Promise<any> {
//   let name: any = url.split('/').reverse()[0]
//   if (name) {
//     name = name.match(/^(.*?)\.umd/)[1]
//   }

//   if (window[name]) {
//     return window[name]
//   }

//   console.log(window[name])

//   return new Promise<Window>((resolve, reject) => {
//     const script = document.createElement('script')
//     script.id = 'test'
//     script.async = true

//     script.addEventListener('load', (e: any) => {
//       fetch(url).then((v: Response) => {
//         v.text().then((v: string) => {
//           // jslint evil: true
//           // eslint no-new-func: "error"
//           const c: any = new Function(v)
//           console.log(c)
//           console.log(window[name])
//         })
//       })
//       resolve(window[name])
//     })
//     script.addEventListener('error', () => {
//       reject(new Error(`Error loading ${url}`))
//     })
//     script.src = url

//     document.appendChild(script)
//   })
// }

export default async function externalComponent (url: string): Promise<any> {
  let name: any = url.split('/').reverse()[0]
  if (name) {
    name = name.match(/^(.*?)\.umd/)[1]
  }

  if (window[name]) {
    return window[name]
  }

  return new Promise<Window>((resolve, reject) => {
    const script = document.createElement('script')
    script.async = true
    script.addEventListener('load', () => {
      resolve(window[name])
    })
    script.addEventListener('error', () => {
      reject(new Error(`Error loading ${url}`))
    })
    script.src = url

    fetch(url).then((v: Response) => {
      v.text().then((v: string) => {
        // eslint-disable-next-line
        // const c: any = new Function(v)
        // eslint-disable-next-line
        const cc: any = eval(v)
        // console.log(c)
        // console.log(cc)
        const ccc = window[name]
        delete window[name]
        console.log(ccc)
        resolve(ccc)
      })
    })
    // document.head.appendChild(script)
  })
}
